import { render, staticRenderFns } from "./servicesSelector.vue?vue&type=template&id=52982ba3&scoped=true&"
import script from "./servicesSelector.vue?vue&type=script&lang=js&"
export * from "./servicesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52982ba3",
  null
  
)

export default component.exports